<mat-expansion-panel class="expansion-panel" #ex>
  <mat-expansion-panel-header>
    <mat-panel-title class="expansion-panel-title">
      <div class="header-container">
        <div class="left">
          <mat-icon class="expansion-panel-header-icon">smart_display</mat-icon>
          <div>
            <div class="title-name">{{ meetingBot().eventTitle }}</div>
            <div class="subtitle-time">
              {{ meetingBot()?.eventStartTime | date: 'h:mm a' }}
            </div>
          </div>
        </div>
        @if (isPrivacyLevelOverridden()) {
          <div class="right">
            <mat-icon>lock</mat-icon>
          </div>
        }
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="summary-container">
    <div class="title">{{ 'COMMON.DESCRIPTION' | translate }}</div>
    <span [innerHTML]="meetingBot().eventDescription || '-'"></span>
  </div>


  <div class="details-container">
    <div>
      <div class="detail-title">{{ 'COMMON.DATE' | translate }}</div>
      <div class="value">{{ meetingBot().eventStartTime | date: 'MMMM d, yyyy' }}</div>
    </div>
    <div>
      <div class="detail-title">{{ 'COMMON.MEETING_LINK' | translate }}</div>
      <a [href]="meetingBot().meetingUrl">{{ meetingBot().meetingUrl }}</a>
    </div>
    <div>
      <div class="detail-title">{{ 'COMMON.SOURCE' | translate }}</div>
      <div class="value">{{ $any(meetingBot().source) | meetingAnalysisSource | translate }}</div>
    </div>
    <div>
      <div class="detail-title">{{ 'COMMON.GUESTS' | translate }}</div>
      <div class="value">
        <glxy-avatar-group class="avatar-group" [avatarList]="avatarList()" [avatarWidth]="28"></glxy-avatar-group>
      </div>
    </div>
    <div>
      <div class="detail-title">
        {{ 'RECORDING_VISIBILITY.TITLE_V2' | translate }}
        <mat-icon (click)="openRecordingInfoDialog()" class="info-icon">info_outline</mat-icon>
      </div>
      @if (!overridingPrivacy()) {
        <glxy-form-field>
          <mat-select [ngModel]="isPrivacyLevelOverridden()" (selectionChange)="changePrivacyOverride($event.value)">
            <mat-option [value]="false">
              {{ 'RECORDING_VISIBILITY.DEFAULT' | translate }}
            </mat-option>
            <mat-option [value]="true">
              {{ 'RECORDING_VISIBILITY.OVERRIDE' | translate }}
            </mat-option>
          </mat-select>
          @if (userThatOverrodePrivacy$ | async; as userThatOverrodePrivacy) {
            <glxy-hint>{{
                'RECORDING_VISIBILITY.UPDATED_BY' | translate: {
                  name: userThatOverrodePrivacy,
                  date: privacyOverrideDate() | date: 'MMM d, yyyy'
                }
              }}
            </glxy-hint>
          }
        </glxy-form-field>
      } @else {
        <div class="override-loading stencil-shimmer"></div>
      }
    </div>
  </div>

</mat-expansion-panel>
